module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat5-71dc92f755863696b92ea9fbb9d90eb8.svg";